import logo from "../../assets/img/Logo_AXIAN.svg";
import whitelogo from "../../assets/img/logo_axian_blanc.svg";
import icon_mobile from "../../assets/img/ICONS-14.png";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {listLanguage} from "../../services/OtherService";
import defaultLang, {englishLang} from "../../config";
import {getoneactualite, getoneactualitebyslug,} from "../../services/ActualiteService";

export default function HeaderNavigation(props) {
    const location = useLocation();
    const navigate = useNavigate();

    const localStorageChange = JSON.parse(localStorage.getItem("lang")) || defaultLang;

    const [isScrolled, setIsScrolled] = useState(false);
    const [languages, setLanguages] = useState([]);

    const lesLangues = async () => {
        const reponse = await listLanguage();
        if (reponse.status === 200) {
            setLanguages(reponse.data);
        }
    };

    const callChangeLanguage = async (lang) => {
        localStorage.setItem("lang", JSON.stringify(lang));
        const currentPath = location.pathname;
        const pathSplit = currentPath.split("/");
        if (pathSplit.length >= 3) {
            if (pathSplit[1] === "actualite" || pathSplit[1] === "news") {
                const reponse = await getoneactualitebyslug(pathSplit[2]);
                if (reponse !== undefined) {
                    if (reponse.status === 200) {
                        if (reponse.data.idtraduction) {
                            const trad = await getoneactualite(reponse.data.idtraduction);
                            if (trad) {
                                if (trad.status === 200) {
                                    navigate("/" + pathSplit[1] + "/" + trad.data.slug);
                                }
                            } else {
                                navigate("/");
                            }
                        } else {
                            navigate("/");
                        }
                    }
                }
            }
        }
        window.location.reload();
    };

    useEffect(() => {
        if (props.isScrolled) setIsScrolled(true);

        lesLangues();

        const handleScroll = () => {
            setIsScrolled(window.scrollY > 100);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [props.isScrolled]);

    const imageSrc = isScrolled ? logo : whitelogo;

    const textsFr = {
        placeholderSearch: "Rechercher...",

        identity: "Identité",
        cluster: "Pôles",
        impact: "Impact Positif",
        commitment: "Engagements",
        investor: "Investisseurs",
        media: "Média",
        career: "Recrutement",
        contact: "Contact",

        linkIdentity: "https://www.axian-group.com/identite/",
        linkCluster: "https://www.axian-group.com/poles/",
        linkImpact: "https://www.axian-group.com/impact-positif/",
        linkCommitment: "https://www.axian-group.com/engagements/",
        linkHomepage: "https://www.axian-group.com/fr/accueil/",
        linkInvestor: "https://www.axian-group.com/investisseurs/",
        linkMedia: "https://mediaroom.axian-group.com/",
        linkCareer: "https://www.axian-group.com/recrutement/",
        linkContact: "https://www.axian-group.com/contact/",
        linkAE: "https://www.axian-energy.com/",
        linkFinancialServices:
            "https://www.axian-group.com/cluster/axian-financial-services/",
        linkDigibankFintech:
            "https://www.axian-group.com/cluster/axian-digibank-fintech/",
        linkProperties: "https://www.axian-group.com/cluster/axian-properties/",
        linkTelecom: "https://www.axian-telecom.com/",
    };

    const textsEn = {
        placeholderSearch: "Search...",

        identity: "Identity",
        cluster: "Business clusters",
        impact: "Positive impact",
        commitment: "Commitments",
        investor: "Investors",
        media: "Media",
        career: "Careers",
        contact: "Contact",

        linkIdentity: "https://www.axian-group.com/en/identity/",
        linkCluster: "https://www.axian-group.com/en/business-clusters/",
        linkImpact: "https://www.axian-group.com/en/positive-impact/",
        linkCommitment: "https://www.axian-group.com/en/commitment/",
        linkHomepage: "https://www.axian-group.com/",
        linkInvestor: "https://www.axian-group.com/en/investors/",
        linkMedia: "https://mediaroom.axian-group.com/",
        linkCareer: "https://www.axian-group.com/en/career/",
        linkContact: "https://www.axian-group.com/en/contact-2/",
        linkAE: "https://www.axian-group.com/en/axian-energy-2/",
        linkFinancialServices:
            "https://www.axian-group.com/en/cluster/axian-financial-services/",
        linkDigibankFintech:
            "https://www.axian-group.com/en/cluster/axian-digibank-fintech/",
        linkProperties: "https://www.axian-group.com/en/cluster/axian-properties/",
        linkTelecom: "https://www.axian-telecom.com/",
    };

    return (
        <>
            <div className={`header-nav${isScrolled ? " header-nav--scrolled" : ""}`} id="id-header-navigation">
                <div className="header-fluid container-fluid ">
                    <div className="row no-padding center w-100">
                        {/* Header website */}
                        <div className="col-12">
                            <ul className="nav nav-menu">
                                <li className="nav-item">
                                    <Link
                                        to={
                                            localStorageChange.code === englishLang.code
                                                ? textsEn.linkIdentity
                                                : textsFr.linkIdentity
                                        }
                                        className="nav-link liens-header"                  >
                                        {localStorageChange.code === englishLang.code
                                            ? textsEn.identity
                                            : textsFr.identity}
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        to={
                                            localStorageChange.code === englishLang.code
                                                ? textsEn.linkCluster
                                                : textsFr.linkCluster
                                        }
                                        className="nav-link liens-header"                  >
                                        {localStorageChange.code === englishLang.code
                                            ? textsEn.cluster
                                            : textsFr.cluster}
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        to={
                                            localStorageChange.code === englishLang.code
                                                ? textsEn.linkImpact
                                                : textsFr.linkImpact
                                        }
                                        className="nav-link liens-header"                  >
                                        {localStorageChange.code === englishLang.code
                                            ? textsEn.impact
                                            : textsFr.impact}
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        to={
                                            localStorageChange.code === englishLang.code
                                                ? textsEn.linkCommitment
                                                : textsFr.linkCommitment
                                        }
                                        className="nav-link liens-header"                  >
                                        {localStorageChange.code === englishLang.code
                                            ? textsEn.commitment
                                            : textsFr.commitment}
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        to={
                                            localStorageChange.code === englishLang.code
                                                ? textsEn.linkHomepage
                                                : textsFr.linkHomepage
                                        }
                                        className="nav-link liens-header"                  >
                                        <img src={imageSrc} alt="Logo AXIAN" />
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        to={
                                            localStorageChange.code === englishLang.code
                                                ? textsEn.linkInvestor
                                                : textsFr.linkInvestor
                                        }
                                        className="nav-link liens-header"                  >
                                        {localStorageChange.code === englishLang.code
                                            ? textsEn.investor
                                            : textsFr.investor}
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        to={
                                            localStorageChange.code === englishLang.code
                                                ? textsEn.linkMedia
                                                : textsFr.linkMedia
                                        }
                                        className="nav-link liens-header"                  >
                                        {localStorageChange.code === englishLang.code
                                            ? textsEn.media
                                            : textsFr.media}
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        to={
                                            localStorageChange.code === englishLang.code
                                                ? textsEn.linkCareer
                                                : textsFr.linkCareer
                                        }
                                        className="nav-link liens-header"                  >
                                        {localStorageChange.code === englishLang.code
                                            ? textsEn.career
                                            : textsFr.career}
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        to={
                                            localStorageChange.code === englishLang.code
                                                ? textsEn.linkContact
                                                : textsFr.linkContact
                                        }
                                        className="nav-link liens-header"                  >
                                        {localStorageChange.code === englishLang.code
                                            ? textsEn.contact
                                            : textsFr.contact}
                                    </Link>
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>
                <div>
                    <div className="dropdown language language-dropdown-search">
                        <i
                            className="bi bi-search dropdown-toggle header-search"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"            ></i>
                        <div className="dropdown-menu">
                            <div className="dropdown-item search">
                                <form action="/search" method="GET">
                                    <input
                                        type="text"
                                        placeholder={
                                            localStorageChange.code === englishLang.code
                                                ? textsEn.placeholderSearch
                                                : textsFr.placeholderSearch
                                        }
                                        name="query"
                                        defaultValue={props.search ? props.search : ""}
                                    />
                                    <button type="submit">
                                        <i className="bi bi-search"></i>
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="dropdown language-dropdown">
                        <button
                            className="dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            {localStorageChange.code}
                        </button>
                        <ul className="dropdown-menu">
                            {languages.map((item) => {
                                return (
                                    <li key={item.idlanguage || item.code}>
                                        <Link
                                            className="dropdown-item"
                                            to="#"
                                            onClick={() => callChangeLanguage(item)}
                                        >
                                            {item.code}
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>

            {/* Header navigation for mobile */}
            <div
                className={
                    isScrolled
                        ? "header-mobile header-mobile-continue"
                        : "header-mobile header-mobile-begin"
                }
            >
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-2 burger">
                            <img
                                src={icon_mobile}
                                alt="LOGO AXIAN"
                                data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasWithBothOptions"
                                aria-controls="offcanvasWithBothOptions"
                            />
                        </div>
                        <div className="col-8 logo-mobile">
                            <Link
                                to={
                                    localStorageChange.code === englishLang.code
                                        ? textsEn.linkHomepage
                                        : textsFr.linkHomepage
                                }
                            >
                                <img src={imageSrc} alt="LOGO AXIAN" />
                            </Link>
                        </div>
                        <div className="col-2">
                            <div
                                className="dropdown language-dropdown-mobile"
                            >
                                <button
                                    className="dropdown-toggle"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    {localStorageChange.code}
                                </button>
                                <ul className="dropdown-menu">
                                    {languages.map((item) => {
                                        return (
                                            <li key={item.idlanguage || item.code}>
                                                <Link
                                                    className="dropdown-item"
                                                    to="#"
                                                    onClick={() => callChangeLanguage(item)}
                                                >
                                                    {item.code}
                                                </Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-2 menu-top">
                    <div
                        className="offcanvas offcanvas-bottom menu-top offcanvas-fullscreen"
                        data-bs-backdrop="false"
                        data-bs-scroll="true"
                        tabIndex="-1"
                        id="offcanvasWithBothOptions"
                        aria-labelledby="offcanvasWithBothOptionsLabel"
                    >
                        <div className="offcanvas-body">
                            <ul className="link-mobile ">
                                <li className="nav-item search">
                                    <form action="/search" method="GET">
                                        <input
                                            type="text"
                                            placeholder={
                                                localStorageChange.code === englishLang.code
                                                    ? textsEn.placeholderSearch
                                                    : textsFr.placeholderSearch
                                            }
                                            name="query"
                                            defaultValue={props.search ? props.search : ""}
                                        />
                                        <button type="submit">
                                            <i className="bi bi-search"></i>
                                        </button>
                                    </form>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        to={
                                            localStorageChange.code === englishLang.code
                                                ? textsEn.linkIdentity
                                                : textsFr.linkIdentity
                                        }
                                        className="nav-link liens-header"
                                    >
                                        {localStorageChange.code === englishLang.code
                                            ? textsEn.identity
                                            : textsFr.identity}
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        to={
                                            localStorageChange.code === englishLang.code
                                                ? textsEn.linkCluster
                                                : textsFr.linkCluster
                                        }
                                        className="nav-link liens-header"
                                    >
                                        {localStorageChange.code === englishLang.code
                                            ? textsEn.cluster
                                            : textsFr.cluster}
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        to={
                                            localStorageChange.code === englishLang.code
                                                ? textsEn.linkImpact
                                                : textsFr.linkImpact
                                        }
                                        className="nav-link liens-header"
                                    >
                                        {localStorageChange.code === englishLang.code
                                            ? textsEn.impact
                                            : textsFr.impact}
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        to={
                                            localStorageChange.code === englishLang.code
                                                ? textsEn.linkCommitment
                                                : textsFr.linkCommitment
                                        }
                                        className="nav-link liens-header"
                                    >
                                        {localStorageChange.code === englishLang.code
                                            ? textsEn.commitment
                                            : textsFr.commitment}
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        to={
                                            localStorageChange.code === englishLang.code
                                                ? textsEn.linkInvestor
                                                : textsFr.linkInvestor
                                        }
                                        className="nav-link liens-header"
                                    >
                                        {localStorageChange.code === englishLang.code
                                            ? textsEn.investor
                                            : textsFr.investor}
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        to={
                                            localStorageChange.code === englishLang.code
                                                ? textsEn.linkMedia
                                                : textsFr.linkMedia
                                        }
                                        className="nav-link liens-header"
                                    >
                                        {localStorageChange.code === englishLang.code
                                            ? textsEn.media
                                            : textsFr.media}
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        to={
                                            localStorageChange.code === englishLang.code
                                                ? textsEn.linkCareer
                                                : textsFr.linkCareer
                                        }
                                        className="nav-link liens-header"
                                    >
                                        {localStorageChange.code === englishLang.code
                                            ? textsEn.career
                                            : textsFr.career}
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        to={
                                            localStorageChange.code === englishLang.code
                                                ? textsEn.linkContact
                                                : textsFr.linkContact
                                        }
                                        className="nav-link liens-header"
                                    >
                                        {localStorageChange.code === englishLang.code
                                            ? textsEn.contact
                                            : textsFr.contact}
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
